export enum TabsIndexes {
  Statements = 0,
  BrokerageNotes = 1
}
